import React from "react";
import "../Footer/Footer.css";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          {/* Logo */}
          <div className="footer-logo-section">
            <img src="/logo.webp" className="logo-f" alt="logo" />
          </div>

          {/* Footer Grid */}
          <div className="footer-grid">
            {/* Company */}
            <div className="footer-col">
              <h4>Company</h4>
              <ul>
                <li>Tour Listings</li>
                <li>Destinations</li>
                <li>Tour Activities</li>
                <li>Tour Types</li>
                <li>How It Work</li>
              </ul>
            </div>

            {/* Explore */}
            <div className="footer-col">
              <h4>Explore</h4>
              <ul>
                <li>Home</li>
                <li>About</li>
                <li>Tour</li>
                <li>Contact</li>
                <li>Destinations</li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-col contact-col">
              <h4>Reach Out</h4>
              <p>Sector 42 Greater Noida</p>
              <p>India</p>
              <p>
                <FaPhoneAlt /> (91) 555–0105 0000
              </p>
              <p>
                <FaEnvelope /> contact@example.com
              </p>
            </div>

            {/* Signup */}
            <div className="footer-col signup-col">
              <h4>Signup for our latest updates</h4>
              <div className="newsletter">
                <input type="email" placeholder="Email address" />
                <button>→</button>
              </div>
              <label className="privacy">
                <input type="checkbox" checked readOnly />I agree to the privacy
                policy.
              </label>
              <div className="social-iconss">
                <FaFacebookF />
                <FaLinkedinIn />
                <FaInstagram />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
      </footer>
      <div className="bottom-footer">
        <p>
          © {new Date().getFullYear()} Travel. All rights reserved. | Designed
          by <span className="infogainsoft">Infogainsoft</span>
        </p>
      </div>
    </>
  );
};

export default Footer;
